import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  locationContainer: {
    marginTop: "10px",
    width: "100%",
  },
  addressText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    color: "#465869",
    lineHeight: "24px",
    marginTop: 10,
  },
  label: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 14,
    color: getBrandCustom("primaryColor", "#308CDB"),
    lineHeight: "24px",
  },
  smallSpacing: {
    marginTop: 16,
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#EDF5FB",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    padding: "0px !important",
    marginRight: 35,
  },
  iconColor: {
    color: "#93A9BD",
  },
  labelNotINformed: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    color: "#9CA6AF",
    lineHeight: "24px",
  },
}));

export default styles;
